import { render, staticRenderFns } from "./ParticaBaseForm.vue?vue&type=template&id=564cd693&"
import script from "./ParticaBaseForm.vue?vue&type=script&lang=ts&"
export * from "./ParticaBaseForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports